// 资金管理
const FinancialReconciliation = () => import('@/view/fund/financial-reconciliation.vue'); // 财务对账
const profitSharingRecord = () => import('@/view/fund/profit-sharing-record.vue'); // 分润记录
const balanceRecord = () => import('@/view/fund/balance-record.vue'); // 团队奖励
const hqRecord = () => import('@/view/fund/hq-record.vue'); // 团队奖励
const hzRecord = () => import('@/view/fund/hz-record.vue'); // 团队奖励
const balanceExamine = () => import('@/view/fund/balance-examine.vue'); // 团队奖励
const messagePublish = () => import('@/view/fund/message-publish.vue'); // 团队奖励
const messageDetail = () => import('@/view/fund/message-detail.vue'); // 团队奖励
const payRecord = () => import('@/view/fund/pay-record.vue'); // 团队奖励
const addPay = () => import('@/view/fund/add-pay.vue'); // 团队奖励
const withdraw = () => import('@/view/fund/withdraw.vue'); // 团队奖励
const team = () => import('@/view/fund/team.vue'); // 团队奖励
const wxCharge = () => import('@/view/fund/wx-charge.vue'); // 团队奖励
const integralRecord = () => import('@/view/fund/integral-record.vue'); // 团队奖励
const goldRecord = () => import('@/view/fund/gold-record.vue'); // 团队奖励
const integralRecord2 = () => import('@/view/fund/integral-record2.vue'); // 团队奖励
const kpiRecord = () => import('@/view/fund/kpi-record.vue'); // 团队奖励
const kpi = () => import('@/view/fund/kpi.vue'); // 团队奖励
const balanceRecord2 = () => import('@/view/fund/balance-record2.vue'); // 团队奖励
const withdrawKpi = () => import('@/view/fund/withdraw-kpi.vue'); // 团队奖励
const withdrawDetail = () => import('@/view/fund/withdraw-detail.vue'); // 团队奖励
const withdrawKpiDetail = () => import('@/view/fund/withdraw-kpi-detail.vue'); // 团队奖励
const integralStatistics = () => import('@/view/fund/integral-statistics'); // 团队奖励
const greenIntegralStatistics = () => import('@/view/fund/green-integral-statistics'); // 团队奖励
const kpiChangesRecord = () => import('@/view/fund/kpi-changes-record.vue'); // 团队奖励
const tpOrderRecord = () => import('@/view/fund/tp-order-record.vue'); // 团队奖励
const withdrawBrand = () => import('@/view/fund/withdraw-brand.vue'); // 团队奖励
const withdrawBrandDetail = () => import('@/view/fund/withdraw-brand-detail.vue'); // 团队奖励
const brandRecord = () => import('@/view/fund/brand-record.vue'); // 团队奖励
const brandChangesRecord = () => import('@/view/fund/brand-changes-record.vue'); // 团队奖励

// const team = () => import('@/view/fund/team.vue'); // 团队奖励
export default [{
    path: '/financial-reconciliation',
    name: 'FinancialReconciliation',
    component: FinancialReconciliation
  },
  {
    path: '/profit-sharing-record',
    name: 'profitSharingRecord',
    component: profitSharingRecord
  },
  {
    path: '/balance-record',
    name: 'balanceRecord',
    component: balanceRecord
  }, {
    path: '/hq-record',
    name: 'hqRecord',
    component: hqRecord
  }, {
    path: '/hz-record',
    name: 'hzRecord',
    component: hzRecord
  },
  {
    path: '/balance-examine',
    name: 'balanceExamine',
    component: balanceExamine
  },
  {
    path: '/message-publish',
    name: 'messagePublish',
    component: messagePublish
  },
  {
    path: '/message-detail',
    name: 'messageDetail',
    component: messageDetail
  },
  {
    path: '/pay-record',
    name: 'payRecord',
    component: payRecord
  },
  {
    path: '/add-pay',
    name: 'addPay',
    component: addPay
  },
  {
    path: '/withdraw',
    name: 'withdraw',
    component: withdraw
  },
  {
    path: '/team',
    name: 'team',
    component: team
  },
  {
    path: '/wx-charge',
    name: 'wxCharge',
    component: wxCharge
  },
  {
    path: '/integral-record',
    name: 'integralRecord',
    component: integralRecord
  },
  {
    path: '/gold-record',
    name: 'goldRecord',
    component: goldRecord
  },
  {
    path: '/integral-record2',
    name: 'integralRecord2',
    component: integralRecord2
  },
  {
    path: '/kpi',
    name: 'kpi',
    component: kpi
  },
  {
    path: '/kpi-record',
    name: 'kpiRecord',
    component: kpiRecord
  },
  {
    path: '/balance-record2',
    name: 'balanceRecord2',
    component: balanceRecord2
  },
  {
    path: '/withdraw-kpi',
    name: 'withdrawKpi',
    component: withdrawKpi
  },
  {
    path: '/withdraw-detail',
    name: 'withdrawDetail',
    component: withdrawDetail
  },
  {
    path: '/withdraw-kpi-detail',
    name: 'withdrawKpiDetail',
    component: withdrawKpiDetail
  },
  {
    path: '/integral-statistics',
    name: 'integralStatistics',
    component: integralStatistics
  },
  {
    path: '/green-integral-statistics',
    name: 'greenIntegralStatistics',
    component: greenIntegralStatistics
  },
  {
    path: '/kpi-changes-record',
    name: 'kpiChangesRecord',
    component: kpiChangesRecord
  },
  {
    path: '/tp-order-record',
    name: 'tpOrderRecord',
    component: tpOrderRecord
  },
  {
    path: '/withdraw-brand',
    name: 'withdrawBrand',
    component: withdrawBrand
  },
  {
    path: '/withdraw-brand-detail',
    name: 'withdrawBrandDetail',
    component: withdrawBrandDetail
  },
  {
    path: '/brand-record',
    name: 'brandRecord',
    component: brandRecord
  },
  {
    path: '/brand-changes-record',
    name: 'brandChangesRecord',
    component: brandChangesRecord
  },
];
